/* eslint-disable @typescript-eslint/no-unused-vars */
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface ReleaseDocumentationState {
  isFetching: boolean;
  error?: string;
}

export interface ReleaseDocumentationPayload {
  fileName: string;
  originalFileName: string;
}

const initialState: ReleaseDocumentationState = {
  isFetching: false,
};

export const releaseDocumentationSlice = createSlice({
  name: 'releaseDocumentation',
  initialState,
  reducers: {
    downloadReleaseDocumentation: (state, _action: PayloadAction<ReleaseDocumentationPayload>) => {
      state.isFetching = true;
    },
    downloadReleaseDocumentationSuccess: (state) => {
      state.isFetching = false;
    },
    downloadReleaseDocumentationFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isFetching = false;
    },
  },
});

export const {
  downloadReleaseDocumentation,
  downloadReleaseDocumentationSuccess,
  downloadReleaseDocumentationFailure,
} = releaseDocumentationSlice.actions;

export default releaseDocumentationSlice.reducer;
